module.exports = __webpack_public_path__ + "img/sign_260730946_1.17e594f4.png";